// extracted by mini-css-extract-plugin
module.exports = {"pScrollGide":"s_bm","pScrollGide__text":"s_bn","pScrollGide__line":"s_bp","anim":"s_bq","animationMarquee":"s_j"};